module.exports = __webpack_public_path__ + "static/media/standard-triplo.b4ff9fc3.jpg";